import { useEffect } from 'react'
import toast from 'react-hot-toast'
import ReactMarkdown from 'react-markdown'
import { useNavigate } from 'react-router-dom'
import rehypeRaw from 'rehype-raw'

import { Button } from '../../../components/Button'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { useAuth } from '../../../hooks/useAuth'
import { useDialogBox } from '../../../hooks/useDialogBox'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { acceptTerms } from '../../../services/appServices'
import { JWT_TOKEN_KEY_NAME } from '../../../utils/constants'

export function Terms() {
  const { currentTerms } = useAppSelector(state => state.app)
  const { signOut } = useAuth()

  const [token] = useLocalStorage(JWT_TOKEN_KEY_NAME)
  const navigate = useNavigate()
  const { showDialog } = useDialogBox()

  async function handleAccept() {
    const result = await acceptTerms(currentTerms.id, token)
    if (result) {
      if (result.success) {
        navigate('/dashboard')
        window.scrollTo({
          top: 0,
        })
      } else {
        showDialog({
          type: 'error',
          title: 'Erro',
          description: result.message,
        })
      }
    }
  }

  useEffect(() => {
    toast(
      'É preciso aceitar nossos termos para continuar utilizando a aplicação.',
      {
        position: 'top-left',
        style: {
          backgroundColor: '#fcad54',
        },
      })
  }, [])

  return (
    <div className="min-h-screen">
      <div className="flex flex-col mx-auto max-w-screen-lg">
        <header className="flex flex-col sm:flex-row justify-between items-center m-4 lg:mx-0">
          <h1
            className="mb-4 sm:mb-0 font-bold text-2xl"
          >
            Termos de uso e serviço - versão {currentTerms.version}
          </h1>
        </header>
        <main className="px-4 lg:px-0 flex-1 h-full">
          <ReactMarkdown className="text-justify" rehypePlugins={[rehypeRaw]}>
            {currentTerms.content}
          </ReactMarkdown>
        </main>
        <footer className="px-2 lg:px-0 flex-1 h-full">
          <div className="flex justify-between gap-4 my-10">
            <Button
              variant="outline"
              onClick={() => signOut()}
            >
              Recusar
            </Button>
            <Button
              type="button"
              onClick={handleAccept}
            >
              Aceitar
            </Button>
          </div>
        </footer>
      </div>
    </div>
  )
}
